"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./ModalFooter.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalFooter = function ModalFooter(_ref) {
  var _ref$tertiaryButtonFn = _ref.tertiaryButtonFn,
      tertiaryButtonFn = _ref$tertiaryButtonFn === void 0 ? function () {} : _ref$tertiaryButtonFn,
      tertiaryButtonHide = _ref.tertiaryButtonHide,
      _ref$tertiaryButtonTe = _ref.tertiaryButtonText,
      tertiaryButtonText = _ref$tertiaryButtonTe === void 0 ? '' : _ref$tertiaryButtonTe,
      _ref$secondaryButtonF = _ref.secondaryButtonFn,
      secondaryButtonFn = _ref$secondaryButtonF === void 0 ? function () {} : _ref$secondaryButtonF,
      secondaryButtonHide = _ref.secondaryButtonHide,
      _ref$secondaryButtonT = _ref.secondaryButtonText,
      secondaryButtonText = _ref$secondaryButtonT === void 0 ? '' : _ref$secondaryButtonT,
      _ref$mainButtonText = _ref.mainButtonText,
      mainButtonText = _ref$mainButtonText === void 0 ? '' : _ref$mainButtonText,
      _ref$mainButtonFn = _ref.mainButtonFn,
      mainButtonFn = _ref$mainButtonFn === void 0 ? function () {} : _ref$mainButtonFn,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'primary' : _ref$type,
      disabled = _ref.disabled,
      singleButton = _ref.singleButton;
  var footerClasses = (0, _classnames.default)('modal-2020-footer', {
    delete: type === 'delete'
  });
  var primaryClasses = (0, _classnames.default)('modal-primary-button', {
    'solo-primary': singleButton
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: footerClasses
  }, tertiaryButtonText && !tertiaryButtonHide && /*#__PURE__*/_react.default.createElement("button", {
    className: "modal-tertiary-button",
    onClick: tertiaryButtonFn
  }, tertiaryButtonText), secondaryButtonText && !secondaryButtonHide && /*#__PURE__*/_react.default.createElement("button", {
    className: "modal-secondary-button",
    onClick: secondaryButtonFn
  }, secondaryButtonText), /*#__PURE__*/_react.default.createElement("button", {
    className: primaryClasses,
    onClick: mainButtonFn,
    disabled: disabled
  }, mainButtonText));
};

var bool = _propTypes.default.bool,
    oneOf = _propTypes.default.oneOf,
    string = _propTypes.default.string,
    func = _propTypes.default.func;
ModalFooter.propTypes = {
  singleButton: bool,
  disabled: bool,
  type: oneOf(['primary', 'delete']),
  mainButtonText: string,
  mainButtonFn: func,
  secondaryButtonText: string,
  secondaryButtonFn: func,
  secondaryButtonHide: bool,
  tertiaryButtonText: string,
  tertiaryButtonFn: func,
  tertiaryButtonHide: bool
};
var _default = ModalFooter;
exports.default = _default;